import React from 'react';

interface ArticleTagsProps {
  tags: string[];
  onTagClick?: (tag: string) => void;
  size?: 'small' | 'medium';
  interactive?: boolean;
}

export function ArticleTags({ 
  tags, 
  onTagClick, 
  size = 'medium',
  interactive = true 
}: ArticleTagsProps) {
  const baseClasses = 'inline-flex items-center rounded-full text-sm transition-colors';
  const sizeClasses = size === 'small' 
    ? 'px-2 py-0.5 text-xs' 
    : 'px-3 py-1';
  
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <button
          key={tag}
          onClick={() => interactive && onTagClick?.(tag)}
          className={`${baseClasses} ${sizeClasses} ${
            interactive
              ? 'hover:bg-blue-50 hover:text-blue-600 cursor-pointer'
              : 'cursor-default'
          } bg-gray-50 text-gray-600`}
          disabled={!interactive}
        >
          #{tag}
        </button>
      ))}
    </div>
  );
}
